/******/ (() => { // webpackBootstrap
/*!***********************************!*\
  !*** ./js/sections/store-time.js ***!
  \***********************************/
/**
 * Store Hours Status Manager
 * Manages the display of open/closed status based on store hours configuration
 */

class StoreTimeManager {
  constructor(config) {
    this.timezone = config.timezone;
    this.schedule = config.schedule;
    // Run update immediately
    this.updateStatus();
    // Update every minute
    setInterval(() => this.updateStatus(), 60000);
  }
  parseTime(timeStr) {
    if (!timeStr || timeStr.toLowerCase() === 'closed') return null;
    var parts = timeStr.split('-');
    if (parts.length !== 2) return null;
    var [openTime, closeTime] = parts.map(t => t.trim());
    var parseHM = t => {
      var [h, m] = t.split(':').map(Number);
      return h * 60 + (m || 0);
    };
    return {
      open: parseHM(openTime),
      close: parseHM(closeTime)
    };
  }
  isStoreOpen() {
    var _this = this;
    var now = new Date();
    var options = {
      timeZone: this.timezone,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };
    var timeStr = now.toLocaleTimeString('en-US', options);
    var [hours, minutes] = timeStr.split(':').map(Number);
    var currentMinutes = hours * 60 + minutes;
    var dayOptions = {
      timeZone: this.timezone,
      weekday: 'short'
    };
    var dayStr = now.toLocaleDateString('en-US', dayOptions);
    var dayMap = {
      'Sun': 0,
      'Mon': 1,
      'Tue': 2,
      'Wed': 3,
      'Thu': 4,
      'Fri': 5,
      'Sat': 6
    };
    var todayIndex = dayMap[dayStr];
    var yesterdayIndex = (todayIndex + 6) % 7;
    var todaySchedule = this.schedule[todayIndex];
    var yesterdaySchedule = this.schedule[yesterdayIndex];
    var checkSchedule = function checkSchedule(schedule) {
      var isYesterday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!schedule || schedule.open === false) return false;
      var times = _this.parseTime(schedule.hours);
      if (!times) return false;
      if (times.open < times.close) {
        // Same day
        return currentMinutes >= times.open && currentMinutes < times.close;
      } else {
        // Overnight
        if (isYesterday) {
          return currentMinutes < times.close;
        } else {
          return currentMinutes >= times.open;
        }
      }
    };
    return checkSchedule(todaySchedule) || checkSchedule(yesterdaySchedule, true);
  }
  updateStatus() {
    var isOpen = this.isStoreOpen();
    var openElements = document.querySelectorAll('.call-button-status-open');
    var closedElements = document.querySelectorAll('.call-button-status-closed');
    openElements.forEach(el => {
      if (isOpen) {
        el.classList.remove('tw-hidden');
      } else {
        el.classList.add('tw-hidden');
      }
    });
    closedElements.forEach(el => {
      if (isOpen) {
        el.classList.add('tw-hidden');
      } else {
        el.classList.remove('tw-hidden');
      }
    });
  }
}

// Export for global access
window.StoreTimeManager = StoreTimeManager;
/******/ })()
;